const config = {
  site: {
    domain: "localhost",
    URL: "http://localhost:3012",
  },

  gaTrackingId: "",

  firebase: {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "",
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "",
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "",
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "",
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "",
    appId: process.env.REACT_APP_FIREBASE_APP_ID || "",
  },
  appCheck: {
    siteKey: process.env.REACT_APP_FIREBASE_APPCHECK_SITE_KEY || "",
  },
  tracking: {
    campaignId:
      process.env.REACT_APP_CAMPAIGN_ID ||
      "security-awareness-recovery-2026-07-30",
    collection:
      process.env.REACT_APP_FIREBASE_EVENT_COLLECTION ||
      "simulation-events",
    clientVersion: "2026-07-30",
  },
};

export default config;
